import posed from 'react-pose'
import React from 'react'
import PropTypes from 'prop-types'

const Box = posed.div({
    hidden: {
        marginLeft: 0,
        marginTop: -200,
        opacity: 0,
        scale: 0.8,
    },
    show: {
        marginLeft: props => -200,
        marginTop: props => -200,
        opacity: 1,
        scale: 1,
        transition: { duration: 500 },
    },
    move1: {
        marginLeft: props => -Math.floor(Math.random() * props.maxMoveX),
        marginTop: props => -Math.floor(Math.random() * props.maxMoveY),
        transition: { duration: 10000, ease: 'linear' },
        scale: props => 1.2,
    },
    move2: {
        marginLeft: props => -Math.floor(Math.random() * props.maxMoveX),
        marginTop: props => -Math.floor(Math.random() * props.maxMoveY),
        transition: { duration: 10000, ease: 'linear' },
        scale: props => 0.9,
    },
})

class AnimatedBackgroundImage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            pose: 'hidden',
        }
    }

    componentDidMount() {
        this.triggerAnimation()
    }

    triggerAnimation() {
        let newPose = null
        let timeout = 0

        switch (this.state.pose) {
            case 'show':
                newPose = 'move1'
                timeout = 0
                break

            case 'move1':
                newPose = 'move2'
                timeout = 0
                break

            case 'move2':
                newPose = 'move1'
                timeout = 0
                break

            default:
                newPose = 'show'
                timeout = 500
                break
        }

        if (this.state.pose != newPose) {
            setTimeout(() => {
                this.setState({
                    pose: newPose,
                })
            }, timeout)
        }
    }

    render() {
        return (
            <Box
                className={this.props.class || 'box'}
                style={this.props.style}
                maxMoveX={this.props.maxMoveX || 400}
                maxMoveY={this.props.maxMoveY || 400}
                flip={true}
                onPoseComplete={pose => this.triggerAnimation()}
                pose={this.state.pose}
            >
                <img style={this.props.imageStyle} src={this.props.image} />
            </Box>
        )
    }
}

AnimatedBackgroundImage.propTypes = {
    image: PropTypes.any,
}

export default AnimatedBackgroundImage
